<script setup>

import axios from "axios";
import {onMounted, ref} from "vue";

const genre = ref({})

function categoryList() {
  const category = 'Steel Structure'
  const params = new URLSearchParams();
  if (category) {
    params.append('category_id_category', category)
  }
  let url = '/api/projects'
  url = url + '?' + params.toString()
  axios
      .get(url)
      .then(response => {
        genre.value = response.data.results.slice(0, 4);
      })
      .catch(error => {
        console.log(error)
      })
}

onMounted(() => {
  categoryList()
})

</script>

<template>

  <!-- kurigram_project_area -->
  <div class="kurigram_project_area project_v5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-left">
              <h3>Related Projects</h3>
              <div class="witr_bar_main">
                <div class="witr_bar_inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="witr_pslide3 all_pslides_color ps1 ps3 service_active">
        <div class="witr_cslide3_idany project_top">
          <!-- kurigram_project_01 -->
          <div class="item_pos col-lg-12" v-for="list in genre" :key="list.id">
            <div class="witr_single_pslide">
              <div class="witr_pslide_image">
                <img :src="list.image_1" alt="">
              </div>
              <div class="witr_content_pslide_text">
                <div class="witr_number_pslide">
                  <h4>01</h4>
                </div>
                <div class="witr_content_pslide">
                  <p>We are best </p>
                  <h3><a :href="'/projects/' + list.site">Best Communication</a></h3>
                </div>
                <div class="witr_pslide_custom">
                  <a :href="'/projects/' + list.site"><span class="ti-arrow-right"></span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">

</style>